import widgetConfigs from '../core/modules/widgetConfigs';
import type { Widget } from '../core/types/Widget';
import { WidgetType } from '../core/types/WidgetType';

const getWidget = (widgetType: WidgetType): Widget => {
  const widget = widgetConfigs.find((widget) => widget.type === widgetType);
  if (!widget) {
    throw new Error(`Widget type ${widgetType} not found in widgetConfigs`);
  }

  return widget;
};

export default getWidget;
